import findMetatag from './findMetatag';

// Boot features
//    'acct-disableUserIdentityCheck' -- disable the logging of userIdentities that are not in the account source list store
//    `acct-reflowAndDefaultTelemetry` -- Indicates that the telemetry for reflow methods that should not be called is enabled
//    `acctErrStorageSetV2` -- When enabled the owa-account-storage package will throw an exception if invalid data is set
//    `acctNoFallback` -- Disables the fallback to global settings account in place of the selected account
//    `acctManualAccountType` -- when enabled, allows the manual selected of the type of account being added
//    `acct-backgroundOobe` -- Enables background oobe experience for account migration
//    `acct-changedAccountError` - Flight for rolling out the ability to show an error when the account has changed during add account flow
//    `acct-icloudOAuthOobe` -- Flight for rolling out the iCloud OAuth flow
//    `acct-addSubscriptionOobe` -- Flight for the add subscription flow in OOBE
//    `acct-OobeDemoView` -- Flight for rolling out the demo view in OOBE
//    `acct-multiCloudInfra` -- Flight for the infra needed to support having multiple accounts from multiple different clouds
//    `acct-sovereignCloudInfraV3` -- Flight for rolling out the sovereign cloud infrastructure
//    `mon-acct-addAccountDeeplink` -- Flight for rolling out the ability to add accounts via deeplinks in oobe
//    `fwk-consoleErrors` -- Surface console errors by showing a dialog
//    `fwk-cssPerf` -- Enables an alternate set of CSS rules that should be more performant during style recalculation
//    `fwk-persistOIDInUrl` -- Persists the OID(user unique identifier) in the root URL
//    `supportonboot` -- launches the support flow if boot fails
//    `disableperfmeasure` -- polyfills performance.measure to be a no-op
//    `accountsapi` -- when enabled the Monarch multi-account UX functionality is enabled in non monarch applications
//    `offlineWeb` -- enables offline in the browser, rather than just in monarch
//    `dev-bootOfflineFolders` -- enables offline folder resolvers
//    `dev-bootOffline` -- boot as if offline disabling service requests until user re-enables in diagnostics
//    `mobxproxies` -- configures MobX to use proxies: https://mobx.js.org/configuration.html#proxy-support
//    `detectcmpfnleaks` -- Enables wrapper around computedFn to detect leaks
//    `disablecmpfn` -- Disables wrapping functions in computedFn to measure the impact
//    `jsselfprofiler` -- This flag lets us know when the JS self profiler is enabled
//    `auth-cacheTokenForMetaOsHub` -- Enable token caching for MetaOS integrations. Token caching involves decoding of bearer token to extract expiry & PUID
//    `auth-disable-onAuthFailedForMetaOsHub` -- Rip cord for teams bug fix that implments onAuthFailed to remove the owa token from the cache when a service request fails with a 401
//    `auth-useAuthTokenClaimsForMetaOsHub` -- Enable use of claims in the token to be used for auth for MetaOS integrations.
//    `cal-reload-pause` -- Reloads the calendar app when the app is cached and pauses loading of resources
//    `cal-subpage-redirect` -- Allows the calendar app to redirect to a subpage when the subpage id is provided through metaOS context
//    `auth-cloudCache-basicAuthPasswordLookup` -- Attempt to get the password for a cloud cache account using basic auth (IMAP/POP, etc.)
//    `auth-msaljs-hosted` -- Enables use of NAA in MetaOS-hosted 1P modules using MSAL.js library.
//    `auth-msaljs-opx-activityfeed` -- Enables use of NAA in ActivityFeed OPX using MSAL.js library.
//    `auth-msaljs-opx-myday` -- Enables use of NAA in MyDay OPX using MSAL.js library.
//    `auth-msaljs-opx-roompanel` -- Enables use of NAA in RoomPanel OPX using MSAL.js library.
//    `auth-msaljs-hostedplaces-teamsios` -- Enables authentication using MSAL.js library in MetaOS-hosted Places for Teams iOS.
//    `auth-msaljs-schedulingpoll` -- Enables authentication using MSAL.js library in Scheduling Poll.
//    `auth-msaljs-hostedcalendar` -- Enables authentication using MSAL.js library for Hosted Calendar scenarios.
//    `auth-msaljs-hostedbookings` -- Enables authentication using MSAL.js library for MetaOS-hosted Bookings scenarios.
//    `auth-msaljs-disableCaeCapabilities` -- Disables CAE capabilities in MSAL.js library for local dev testing only.
//    `auth-msaljs-useDelegationToken` -- Enables the use of delegation token for MSAL consumers.
//    `auth-msaljs-EnableLogging` -- Enables MSAL.js package level logging.
//    `auth-msaljs-enableEAR-enterprise` -- Enables EAR protocol flow for enterprise accounts.
//    `auth-msaljs-enableEAR-consumer` -- Enables EAR protocol flow for consumer accounts.
//    `auth-naa-use-embedded-client-id` -- Enables passing the embedded client id in the brokered token request for NAA instead of passing it as an extra query parameter or in the body of the token request, which is required for some embedded scenarios like DIME.
//    `auth-codeChallenge` -- Enables PKCE flow for Google cloud cache accounts.
//    `auth-icloud-encodeRedirectUri` -- Enables shouldEncodeRedirectUri additional parameter for iCloud cloud cache auth code flow.
//    `acct-mbxpkg-boot` -- used to control the usage of the owa-mailbox-package within the application
//    `auth-disableAnonymousTokenForHeader` -- Disables the use of auth tokens for anonymous mailboxInfos.
//    `fwk-loc-single-v2`  -- Use a single observable for all localized strings
//    `fwk-delay-policy-tips-v2` -- Move policy tips from StartupData to NonBoot
//    `acct-roaming` -- Enables the roaming feature for accounts
//    `msplaces-hosted-localsessiondata-v2` -- Enables the use of local session data in hosted places
//    `msplaces-offline-sync-engine` -- Enables the use of the offline sync engine in places
//    `msplaces-app-boot-sequence` -- Enables tracing the boot steps of the Places app
//    `cal-enable-HybridModel-for-calendarSharing` -- Enables the HybridModel for calendar sharing
//    `fwk-worker-script-trusted-types-policy` -- Enables the sanitize of the urls inside the worker trusted types policy
//    `cal-organizationCalendars` -- Enables the organization calendars feature
//    `fwk-init-acc-locstore` -- Enable initializing account store from local storage
//    `auth-mon-lookupUniqueIdentity2` -- Tries to prepopulate the unique identity before asking Native Host for a token
//    `fwk-enable-owa-loop-trusted-types-policy` -- Enables the OWA loop trusted types policy.
//    `fwk-enforce-trusted-types` -- Set the trusted types policy to enforce mode to block untrusted code.
//    `cal-enable-teamrhythm-extprop-gcv` -- Enables the use of the team rhythm extended property parameter for calendar view call
//    `cal-request-skypeTeamsProperties-startupdata` -- Requests for skypeTeamsProperties in Startupdata call.
//    `auth-tds ` -- Enables getting auth token on TDS machine
//    `fwk-new-monarch-header` -- Enables the new header in Monarch
//    `perf-prioritize-tokenFetch` -- Prioritize token fetch to improve performance
//    `auth-tokenCache-expiryDate` -- Enables the use of nativehost expiry date in the token cache instead of ExpiresIn
//    `cal-enable-scheduling-poll` -- Enables the scheduling poll feature in calendar
//    `cal-appCaching-nonBlockingTheme` -- Downgrades initializeTheme to non-blocker and stops awaiting non-blocking handlers for Calendar
//    `cal-disable-appCaching-lifecycle-handlers` -- Disables app lifecycle handlers (onResume and beforeSuspendOrTerminate) for app caching in non-Teams environments
//    `auth-naa-bookings` -- Use the Bookings App ID for NAA authentication in Bookings web app
//    `nh-recoveryInterop` -- Enables the use of interop APIs for recovery actions (restartHost, shutdownApplication) during boot failures
//    `nh-windowstatebootinterop` -- Enable window state APIs to use Interop instead of PIE at boot
//    `nh-splashCloseButton` -- Enables the close button in the native splash screen
//    `auth-enableJWEForOwaConsumer` -- Enables JWE Flow for Consumer in Owa.
//    `auth-unifiedCache` -- Enabled using new unified token cache for owa-tokenprovider and native-host-auth
//    `auth-login-hint-from-auth-config` -- Enable reading cached login_hint from auth config in getLoginHint during boot-sensitive auth flows
//    `auth-login-hint-log-fallback` -- Enable MsalLoginHintFallback telemetry when getLoginHint falls back to UPN-based identifiers
//    `auth-login-hint-validate-login` -- Enable cross-account token identity validation after user login
//    `auth-login-hint-validate-naa` -- Enable cross-account token identity validation after NAA brokered token acquisition
//    `auth-msaljs-iframeTimeoutTelemetry` -- Enables experimental late-response telemetry for silent iframe calls in MSAL
//    `cal-metaos-init-error-recovery` -- Enables error recovery and retry logic for MetaOS app initialization failures
//    `cal-early-session-data-fetch` -- Start session data fetches earlier in boot by awaiting only account source list initialization
//    `fwk-ows-gateway-legacy-auth-append` -- Ripcord to revert to legacy auth header append behavior that always appends gateway token even when custom Authorization header provided

export type BootFeature =
    | 'acct-disableUserIdentityCheck'
    | 'acct-reflowAndDefaultTelemetry'
    | 'acctErrStorageSetV2'
    | 'acctNoFallback'
    | 'acctManualAccountType'
    | 'acct-changedAccountError'
    | 'acct-icloudOAuthOobe'
    | 'acct-addSubscriptionOobe'
    | 'acct-backgroundOobe'
    | 'acct-OobeDemoView'
    | 'acct-multiCloudInfra'
    | 'acct-sovereignCloudInfraV3'
    | 'mon-acct-addAccountDeeplink'
    | 'fwk-consoleErrors'
    | 'fwk-cssPerf'
    | 'fwk-enable-owa-loop-trusted-types-policy'
    | 'fwk-enforce-trusted-types'
    | 'fwk-persistOIDInUrl'
    | 'supportonboot'
    | 'disableperfmeasure'
    | 'accountsapi'
    | 'offlineWeb'
    | 'dev-bootOfflineFolders'
    | 'dev-bootOffline'
    | 'mobxproxies'
    | 'emergencyDisableBpos'
    | 'detectcmpfnleaks'
    | 'disablecmpfn'
    | 'jsselfprofiler'
    | 'auth-cacheTokenForMetaOsHub'
    | 'auth-disable-onAuthFailedForMetaOsHub'
    | 'auth-useAuthTokenClaimsForMetaOsHub'
    | 'cal-reload-pause'
    | 'cal-subpage-redirect'
    | 'auth-cloudCache-basicAuthPasswordLookup'
    | 'auth-msaljs-hosted'
    | 'auth-msaljs-opx-activityfeed'
    | 'auth-msaljs-opx-myday'
    | 'auth-msaljs-opx-roompanel'
    | 'auth-msaljs-hostedplaces-teamsios'
    | 'auth-msaljs-schedulingpoll'
    | 'auth-msaljs-mini-business'
    | 'auth-msaljs-hostedcalendar'
    | 'auth-msaljs-hostedbookings'
    | 'auth-msaljs-disableCaeCapabilities'
    | 'auth-msaljs-useDelegationToken'
    | 'auth-msaljs-EnableLogging'
    | 'auth-msaljs-enableEAR-enterprise'
    | 'auth-msaljs-enableEAR-consumer'
    | 'auth-msaljs-domainHint'
    | 'auth-msaljs-consumer-boot-errorhandler'
    | 'auth-naa-use-embedded-client-id'
    | 'auth-codeChallenge'
    | 'auth-icloud-encodeRedirectUri'
    | 'auth-disableAnonymousTokenForHeader'
    | 'acct-mbxpkg-boot'
    | 'disableConcurrency'
    | 'workerAsyncLoad'
    | 'fwk-loc-single-v2'
    | 'fwk-delay-policy-tips-v2'
    | 'acct-roaming'
    | 'msplaces-hosted-localsessiondata-v2'
    | 'msplaces-offline-sync-engine'
    | 'fwk-ows-gateway-legacy-auth-append'
    | 'msplaces-app-boot-sequence'
    | 'cal-enable-HybridModel-for-calendarSharing'
    | 'fwk-init-acc-locstore'
    | 'fwk-worker-patch'
    | 'cal-organizationCalendars'
    | 'auth-mon-lookupUniqueIdentity2'
    | 'cal-enable-teamrhythm-extprop-gcv'
    | 'cal-request-skypeTeamsProperties-startupdata'
    | 'auth-tds'
    | 'fwk-new-monarch-header'
    | 'perf-prioritize-tokenFetch'
    | 'auth-tokenCache-expiryDate'
    | 'cal-enable-scheduling-poll'
    | 'cal-appCaching-nonBlockingTheme'
    | 'cal-disable-appCaching-lifecycle-handlers'
    | 'auth-naa-bookings'
    | 'nh-recoveryInterop'
    | 'nh-windowstatebootinterop'
    | 'nh-splashCloseButton'
    | 'auth-enableJWEForOwaConsumer'
    | 'auth-unifiedCache'
    | 'auth-authUxCallbacksInclusionRipcord'
    | 'auth-login-hint-from-auth-config'
    | 'auth-login-hint-log-fallback'
    | 'auth-login-hint-validate-login'
    | 'auth-login-hint-validate-naa'
    | 'auth-alwaysIncludeMailboxInfoForSessionData'
    | 'cal-metaos-init-error-recovery'
    | 'cal-early-session-data-fetch'
    | 'auth-msaljs-iframeTimeoutTelemetry';

interface CustomGlobalThis {
    bootFlights: string[];
}

declare var globalThis: CustomGlobalThis;

// these are specifically for features that need to be decided before userbootsettings comes back.
let bootFlights: string[] | undefined;
let bootFlightsLowercase: Set<string> | undefined;
let bootFlightsWithAllocationIds: string[] | undefined;
export function isBootFeatureEnabled(feature: BootFeature): boolean {
    return getBootFlightsLowercase().has(feature.toLowerCase());
}

export function getBootFlights(): string[] {
    if (!bootFlights) {
        const meta = findMetatag('bootFlights');
        bootFlights = meta
            ? meta.split(',').map(m => m.split(':')[0])
            : globalThis.bootFlights ?? [];
    }
    return bootFlights;
}

export function getBootFlightsWithAllocationIds(): string[] {
    if (!bootFlightsWithAllocationIds) {
        const meta = findMetatag('bootFlights');

        bootFlightsWithAllocationIds = meta ? meta.split(',') : [];
    }
    return bootFlightsWithAllocationIds;
}

export function test_reset(): void {
    bootFlights = undefined;
    bootFlightsLowercase = undefined;
}

function getBootFlightsLowercase(): Set<string> {
    if (!bootFlightsLowercase) {
        bootFlightsLowercase = new Set(getBootFlights().map(key => key.toLowerCase()));
    }
    return bootFlightsLowercase;
}
